import * as React from "react";
import { Routes, Route } from "react-router-dom";
import { ApplicationContainer } from "./ui/containers/applicationContainer";
import { HomeViewContainer } from "./ui/containers/homeViewContainer";
import { JoinViewContainer } from "./ui/containers/joinViewContainer";
import { CreateViewContainer } from "./ui/containers/createViewContainer";
import { AboutViewContainer } from "./ui/containers/aboutViewContainer";

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<HomeViewContainer />} />
      <Route path="/app" element={<ApplicationContainer />} />
      <Route path="/join" element={<JoinViewContainer />} />
      <Route path="/create" element={<CreateViewContainer />} />
      <Route path="/about" element={<AboutViewContainer />} />
    </Routes>
  );
}
